export const errors = {
  emailVerificationSent: 'Error al enviar el correo',
  msgEmailVerificationSent: 'Correo no enviado, intentalo de nuevo',
  msgPassEmailVerificationSent: 'Correo no encontrado, verifica tu correo y intentalo de nuevo',
  emailChangeTryAgain: 'Error, al cambiar el correo, inténtelo nuevamente',
  tryAgain: 'Error, intenta de nuevo',
  phoneNumberNotFound: 'El número de teléfono no se encuentra registrado',
  passwordChangedUnsuccessfully: 'Error, al cambiar la contraseña, inténtalo de nuevo',
};
